import { FC } from 'react'
import Select from 'react-select'
import { SelectContainer } from './styles'

interface Option {
  label: string,
  value: number,
  is_market: boolean
}

interface FulfillmentCenterSelected {
  name: string
  id: number
  is_market: boolean
}

interface Props {
  options: Option[]
  fulfillmentCenterSelected?: FulfillmentCenterSelected,
  setFulfillmentCenterSelected: (item: FulfillmentCenterSelected | undefined) => void
  loading: boolean
}

const SelectFulfillmentCenter: FC<Props> = ({
  fulfillmentCenterSelected, loading, options, setFulfillmentCenterSelected,
}) => (
  <SelectContainer>
    <Select
      id='fufillmentcenter-select'
      options={options}
      placeholder='Selecione um FC'
      value={
          fulfillmentCenterSelected
            ? {
              label: fulfillmentCenterSelected.name,
              value: fulfillmentCenterSelected.id,
              is_market: fulfillmentCenterSelected.is_market,
            }
            : null
        }
      loadingMessage={() => "Carregando FC's ativos"}
      noOptionsMessage={() => "Não há FC's carregados"}
      onChange={(option) => {
        setFulfillmentCenterSelected({
          id: option!.value,
          name: option!.label,
          is_market: option!.is_market,
        })
      }}
      isLoading={loading}
    />
  </SelectContainer>
)

export default SelectFulfillmentCenter
